import { ComponentWithAs, Flex, IconProps, Spacer, useToken } from "@chakra-ui/react";
import React, { ReactNode } from "react";

import { RanaHeading } from "@nens/ranalib";

import CollapseArrowButton from "./CollapseArrowButton";

interface Props {
  Icon?: ComponentWithAs<"svg", IconProps> | React.FunctionComponent<React.SVGProps<SVGSVGElement>>; //MapIcon
  children: ReactNode; //formattedMessage
}

const LeftMenuHeader: React.FC<Props> = ({ Icon, children }) => {
  const [analytic] = useToken("colors", ["brand.analytic"]);
  return (
    <Flex alignItems="center" mx={4} mb={4}>
      {Icon && <Icon color={analytic} fill={analytic} width="22px" height="22px" />}
      <RanaHeading fontWeight={500} type="h4" color={analytic} ml={Icon ? 2 : 0}>
        {children}
      </RanaHeading>
      <Spacer />
      <CollapseArrowButton />
    </Flex>
  );
};

export default LeftMenuHeader;
